export default __webpack_public_path__ + "static/media/logo2.699a541a.png";